import React from "react";
import { Table } from "@pickit/pickit-components";
import "./documentManager.scss";
import { VersionHistoryCardProps } from "./types";

export const VersionHistoryCard = <T = Record<string, unknown>>({
  testId,
  title,
  headers,
  data,
  emptyText,
}: VersionHistoryCardProps<T>): JSX.Element => (
  <div className="doc-manager-history-card">
    <div className="doc-manager-card-header">
      <h2
        className="doc-manager-section-title"
        data-testId={`${testId}-version-history-title`}
      >
        {title}
      </h2>
    </div>
    <div className="doc-manager-history-body" data-testId={`${testId}-version-history-body`}>
        <Table<T>
          headers={headers}
          data={data}
          testId={`${testId}-versions-table`}
          noResultsText={emptyText}
        />
    </div>
  </div>
);

export default VersionHistoryCard;
